import { useState } from 'react';
import styled from 'styled-components';
import { Button } from 'antd';

import { IContact } from '../../common/model/mailchimp/contact.model';
import useI18n from '../../common/hooks/useI18n';

import { ModalForm } from '../shared';

type Props = {
  onButtonClick: (contact: IContact) => void;
  text?: JSX.Element;
  size?: 'middle' | 'large';
  limitWidth?: boolean;
  className?: string;
};

const RequestInfoButton = ({
  onButtonClick,
  text,
  size = 'large',
  limitWidth = false,
  className,
}: Props): JSX.Element => {
  const i18n = useI18n();

  const [modalVisible, setModalVisible] = useState(false);

  return (
    <div
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <Button
        className={className}
        style={{ width: limitWidth ? 'auto' : '100%' }}
        htmlType="button"
        type="primary"
        size={size}
        onClick={() => setModalVisible(true)}
      >
        {text || i18n.t('flatDetail.actions.requestInfo')}
      </Button>
      <ModalForm
        isSellerMode={false}
        visible={modalVisible}
        onOk={(contact) => {
          onButtonClick(contact);
          setModalVisible(false);
        }}
        onCancel={() => {
          setModalVisible(false);
        }}
      />
    </div>
  );
};

export default styled(RequestInfoButton)`
  font-weight: 500;
  border-radius: 20px;
`;
